<template>
  <div
      :class="login_modal_visible?'modal fade theme-modal view-modal show shadow-lg fa-border':'modal fade theme-modal view-modal shadow-lg fa-border'"
      id="view" tabindex="-1" aria-labelledby="exampleModalLabel"
      v-if="login_modal_visible"
      aria-modal="true" role="dialog" style="display: block; padding-left: 0px; background-color: rgba(0, 0, 0, 0.3)">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header p-0">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="toggleModalLogin">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row g-sm-4 g-2">
            <div class="col-md-12">
              <GoogleLogin :callback="callback" class="w-100"/>
            </div>
            <div class="col-12">
              <el-tabs v-model="activeName" class="demo-tabs">
                <el-tab-pane label="Login to Account" name="first"></el-tab-pane>
                <el-tab-pane label="Create Account" name="second"></el-tab-pane>
              </el-tabs>
              <div class="" v-if="activeName==='first'">
                <form class="row g-4" @submit.prevent="signIn">
                  <div class="col-12">
                    <div class="form-floating theme-form-floating log-in-form">
                      <input type="text" class="form-control" id="email"
                             placeholder="Email Address"
                             v-model="form.login">
                      <label for="email">
                        Phone Number / Email Address
                      </label>
                      <span class="text-danger"
                            v-if="login_errors?.data?.errors?.login">
                          {{ login_errors?.data?.errors?.login[0] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-floating theme-form-floating log-in-form">
                      <input type="password" class="form-control" id="password"
                             placeholder="Password" v-model="form.password">
                      <label for="password">Password</label>
                      <span class="text-danger"
                            v-if="login_errors?.data?.errors?.password">
                            {{ login_errors?.data?.errors?.password[0] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="forgot-box">
                      <div class="form-check ps-0 m-0 remember-box">
                        <input class="checkbox_animated check-box" type="checkbox"
                               id="flexCheckDefault">
                        <label class="form-check-label" for="flexCheckDefault">Remember
                          me</label>
                      </div>
                      <a href="/reset" class="forgot-password">
                        Forgot Password?
                      </a>
                    </div>
                  </div>

                  <div class="col-12">
                    <button class="btn btn-animation w-100 justify-content-center" type="submit"
                            v-loading="login_loading">
                      Log In
                    </button>
                  </div>
                </form>
              </div>
              <div class="" v-if="activeName==='second'">
                <form class="row g-4" @submit.prevent="signUp">
                  <div class="col-12">
                    <div class="form-floating theme-form-floating">
                      <input type="text" class="form-control" id="fullname" placeholder="Full Name"
                             v-model="form.full_name">
                      <label for="fullname">Full Name</label>
                      <span class="text-danger"
                            v-if="errors?.data?.errors?.full_name  && this.has_errors">
                                      {{ errors?.data?.errors?.full_name[0] }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating theme-form-floating">
                      <input type="text" class="form-control" id="phone" placeholder="Phone Number"
                             v-model="form.phone">
                      <label for="email">Phone Number</label>
                      <span class="text-danger"
                            v-if="errors?.data?.errors?.phone  && this.has_errors">
                                      {{ errors?.data?.errors?.phone[0] }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating theme-form-floating">
                      <input type="email" class="form-control" id="email" placeholder="Email Address"
                             v-model="form.email">
                      <label for="email">Email Address</label>
                      <span class="text-danger"
                            v-if="errors?.data?.errors?.email  && this.has_errors">
                        {{ errors?.data?.errors?.email[0] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-floating theme-form-floating">
                      <input type="password" class="form-control" id="password"
                             placeholder="Password" v-model="form.password">
                      <label for="password">Password</label>
                      <span class="text-danger"
                            v-if="errors?.data?.errors?.password  && this.has_errors">
                                      {{ errors?.data?.errors?.password[0] }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating theme-form-floating">
                      <input type="password" class="form-control" id="password"
                             placeholder="Confirm Password" v-model="form.password_confirmation">
                      <label for="password">Confirm Password</label>
                      <span class="text-danger"
                            v-if="errors?.data?.errors?.password_confirmation  && this.has_errors">
                                      {{ errors?.data?.errors?.password_confirmation[0] }}
                      </span>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="forgot-box">
                      <div class="form-check ps-0 m-0 remember-box">
                        <input class="checkbox_animated check-box" type="checkbox" v-model="form.terms"
                               id="flexCheckDefault">
                        <label class="form-check-label" for="flexCheckDefault">
                          I agree with
                          <span>Terms</span> and <span>Privacy</span></label>
                        <span class="text-danger"
                              v-if="errors?.data?.errors?.terms  && this.has_errors">
                                      {{ errors?.data?.errors?.terms[0] }}
                      </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <button class="btn btn-animation w-100" type="submit" v-loading="loading">Sign Up</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {decodeCredential, googleOneTap} from 'vue3-google-login'
import {ElTabPane, ElTabs} from 'element-plus'

export default {
  name: 'QuickAuthComponent',
  props: {
    visible: false
  },
  data() {
    return {
      activeName: 'first',
      form: {}
    }
  },
  components: {
    ElTabs, ElTabPane
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['profile/loggedIn']
    },
    ...mapGetters({
      'login_modal_visible': 'profile/login_modal_visible',
      'login_loading': 'profile/loading',
      'login_errors': 'profile/errors',
      'login_has_errors': 'profile/has_errors',
      'loading': 'users/loading',
      'errors': 'users/errors',
      'has_errors': 'users/has_errors',
      'login': 'users/loading',
      'user': 'profile/user'
    })
  },
  methods: {
    signUp() {
      this.createUser(this.form).then(() => {
        if (!this.has_errors) {

        }
      })
    },
    signIn() {
      this.loginUser(this.form).then(() => {
        if (!this.has_errors && this.user !== null) {
          this.$store.commit('profile/setLoginModalVisible', false)
          window.location.reload()
        }
      })
    },
    toggleModalLogin() {
      this.$store.commit('profile/setLoginModalVisible', false)
    },
    ...mapActions({
      'loginUser': 'profile/authenticate',
      'createUser': 'users/registerUser',
      'validateGoogleLogin': 'profile/validateGoogleLogin'
    }),
    setupGoogleOneTap() {
      googleOneTap()
          .then((response) => {
            // This promise is resolved when user selects an account from the the One Tap prompt
            const userData = decodeCredential(response.credential)
            userData.token = response?.credential
            this.validateGoogleLogin(userData).then(() => {
              if (!this.login_has_errors) {
                window.location.reload()
              }
            })
          })
          .catch((error) => {
            // console.log("Handle the error", error)
          })
    },

    callback(response) {
      // This callback will be triggered when the user selects or login to
      // his Google account from the popup
      const userData = decodeCredential(response.credential)
      userData.token = response?.credential
      this.validateGoogleLogin(userData).then(() => {
        if (!this.login_has_errors) {
          window.location.reload()
        }
      })
    }
  },
  created() {
    if (!this.isLoggedIn) {
      this.setupGoogleOneTap()
    }
  }
}
</script>